// React
import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import MetaTags from 'react-meta-tags';
import { Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// Injections
import { assets } from '../../containers/assetsInjection';
import {
  PageWrapper,
  LoadingScreen,
} from '../../containers/componentsInjection';

// View
import { CategoriesPlansPage } from './view';

// Redux
import { CategoryPlans, DeleteCategoryPlans } from '../../../../store/actions';

const CategoriesPlans = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { images } = assets;

  const { error, categoryPlans, success } = useSelector((state) => ({
    error: state.CategoryPlans.error,
    categoryPlans: state.CategoryPlans.categoryPlans,
    success: state.CategoryPlans.success,
  }));

  const handleDelete = (id) => {
    dispatch(DeleteCategoryPlans(id));
  };

  useEffect(() => {
    dispatch(CategoryPlans());
  }, [dispatch, success]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Tipo</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link
                to={`/configuracoes/tabelas/categorias-planos/editar/${cell.id}`}
                className="currency_name"
              >
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  return categoryPlans ? (
    <CategoriesPlansPage
      columns={columns}
      history={history}
      handleDelete={handleDelete}
      categoryPlans={categoryPlans}
    />
  ) : (
    <PageWrapper title={'Categorias de Planos'}>
      <LoadingScreen />
    </PageWrapper>
  );
};

export default CategoriesPlans;
